/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_No_KeysInputs */

const en_settings_apikeys_no_keys = /** @type {(inputs: Settings_Apikeys_No_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No API keys yet. Create one to get started.`)
};

/**
* | output |
* | --- |
* | "No API keys yet. Create one to get started." |
*
* @param {Settings_Apikeys_No_KeysInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_no_keys = /** @type {((inputs?: Settings_Apikeys_No_KeysInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_No_KeysInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_no_keys(inputs)
});
export { settings_apikeys_no_keys as "settings.apikeys.no_keys" }